// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const CvssModifiedAttackVectorSchema = z.enum(['X','N','A','L','P'] as const);

export type CvssModifiedAttackVectorType = `${z.infer<typeof CvssModifiedAttackVectorSchema>}`

export default CvssModifiedAttackVectorSchema;
